<button nz-button nzBlock nz-dropdown [nzDropdownMenu]="menu4">
  {{ messagingEventLabel | translate }}
  <i nz-icon nzType="down"></i>
</button>
<div class="spacer"></div>

<nz-dropdown-menu #menu4="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="setMessagingEvent(eventType.SMS)">
      {{ getStrPath("SMS.TITLE") | translate }}
    </li>
    <li nz-menu-item (click)="setMessagingEvent(eventType.SUB_BRANDING)">
      {{ getStrPath("SUB_BRANDING.TITLE") | translate }}
    </li>
    <li nz-menu-item (click)="setMessagingEvent(eventType.APP_PUSH)">
      {{ getStrPath("APP_PUSH.TITLE") | translate }}
    </li>
    <li nz-menu-item (click)="setMessagingEvent(eventType.APP_PUSH_URL)">
      {{ getStrPath("APP_PUSH_URL.TITLE") | translate }}
    </li>
  </ul>
</nz-dropdown-menu>

<form nz-form [formGroup]="messagingForm" (ngSubmit)="submitForm()">
  <nz-form-item
    *ngIf="this.messagingForm.get('eventValues.title')"
    formGroupName="eventValues"
  >
    <nz-form-control [nzXs]="24" [nzErrorTip]="titleErrorTpl">
      <input
        nz-input
        formControlName="title"
        type="text"
        [placeholder]="getStrPath('APP_PUSH_URL.MESSAGE_TITLE') | translate"
      />
      <ng-template #titleErrorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          {{ getStrPath("ERR.REQUIRED_TITLE") | translate }}
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item
    *ngIf="this.messagingForm.get('eventValues.redirect_url')"
    formGroupName="eventValues"
  >
    <nz-form-control [nzXs]="24" [nzErrorTip]="redirect_urlErrorTpl">
      <input
        nz-input
        formControlName="redirect_url"
        type="text"
        [placeholder]="getStrPath('APP_PUSH_URL.REDIRECT_URL') | translate"
      />
      <ng-template #redirect_urlErrorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          {{ getStrPath("ERR.REQUIRED_REDIRECT_URL") | translate }}
        </ng-container>
        <ng-container *ngIf="control.hasError('url')">
          {{ getStrPath("ERR.INVALID_URL") | translate }}
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item
    *ngIf="this.messagingForm.get('eventValues.expiration')"
    formGroupName="eventValues"
  >
    <nz-form-control [nzXs]="24" [nzErrorTip]="expirationErrorTpl">
      <nz-select
        nzAllowClear
        formControlName="expiration"
        [nzPlaceHolder]="getStrPath('SUB_BRANDING.EXPIRATION') | translate"
      >
        <nz-option
          *ngFor="let expiration of notificationExpirations"
          [nzLabel]="
            getStrPath('DROPDOWN.EXPIRATION.' + expiration.text)
              | translate: { value: expiration.digit }
          "
          [nzValue]="expiration.value"
        >
        </nz-option>
      </nz-select>
      <ng-template #expirationErrorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          {{ getStrPath("ERR.REQUIRED_EXPIRATION") | translate }}
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item
    *ngIf="this.messagingForm.get('eventValues.network_name')"
    formGroupName="eventValues"
  >
    <nz-form-control [nzXs]="24" [nzErrorTip]="network_nameErrorTpl">
      <input
        nz-input
        formControlName="network_name"
        type="text"
        [placeholder]="getStrPath('SUB_BRANDING.NETWORK_NAME') | translate"
      />
      <ng-template #network_nameErrorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          {{ getStrPath("ERR.REQUIRED_NETWORK_NAME") | translate }}
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item
    *ngIf="this.messagingForm.get('eventValues.sub_brand_folder')"
    formGroupName="eventValues"
  >
    <nz-form-control [nzXs]="24" [nzErrorTip]="sub_brand_folderErrorTpl">
      <input
        nz-input
        formControlName="sub_brand_folder"
        type="text"
        [placeholder]="getStrPath('SUB_BRANDING.SUB_BRAND_FOLDER') | translate"
      />
      <ng-template #sub_brand_folderErrorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          {{ getStrPath("ERR.REQUIRED_SUB_BRAND") | translate }}
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item
    *ngIf="this.messagingForm.get('eventValues.body')"
    formGroupName="eventValues"
  >
    <nz-form-control [nzXs]="24" [nzErrorTip]="bodyErrorTpl">
      <textarea
        rows="4"
        nz-input
        formControlName="body"
        [placeholder]="getStrPath('SUB_BRANDING.TEXT_BODY') | translate"
      ></textarea>
      <ng-template #bodyErrorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          {{ getStrPath("ERR.REQUIRED_TXT_BODY") | translate }}
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item
    *ngIf="this.messagingForm.get('eventValues.message')"
    formGroupName="eventValues"
  >
    <nz-form-control [nzXs]="24" [nzErrorTip]="messageErrorTpl">
      <textarea
        rows="4"
        nz-input
        formControlName="message"
        [placeholder]="getStrPath('SMS.MESSAGE') | translate"
      ></textarea>
      <ng-template #messageErrorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          {{ getStrPath("ERR.REQUIRED_MESSAGE") | translate }}
        </ng-container>
        <ng-container *ngIf="control.hasError('maxlength')">
          {{ "FORM.ERR.MAX_CHARS" | translate: { value: 400 } }}
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-control>
      <button
        [nzLoading]="isSubmitting"
        [disabled]="!messagingForm.valid"
        nz-button
        [nzType]="'primary'"
        nzBlock
      >
        {{ "BUTTON.SEND" | translate }}
      </button>
    </nz-form-control>
  </nz-form-item>
</form>
